import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFeatureFlags } from '../contexts/FeatureFlagsContext';
import NotificationModal from './NotificationModal';

export const FeatureDisabledBanner: React.FC = () => {
  const { disabledNotification, clearDisabledNotification } = useFeatureFlags();
  const { t } = useTranslation(['common']);

  if (!disabledNotification) return null;

  return (
    <NotificationModal
      isOpen={Boolean(disabledNotification)}
      type="warning"
      title={t('common:notifications.warning', 'Fonctionnalité désactivée')}
      message={disabledNotification.message || `La fonctionnalité (${disabledNotification.feature}) est actuellement désactivée.`}
      onClose={clearDisabledNotification}
      autoCloseDelay={8000}
    />
  );
};
